import { CookieOptions } from 'express';
import { CookieService } from 'ngx-cookie-service';
export class StorageCookieModel<T> {
  constructor(
    private key: string,
    private cook: CookieService,
    private defaultValue?: string,
    private isObject = false,
    private document: Document = null as any,
  ) { }

  buildOptions() {
    let currentDate = new Date();
    currentDate = new Date(currentDate.setHours(currentDate.getDay() + 360));

    return {
      expires: currentDate,
      path: '/',
      domain: this.document?.location?.host?.includes('localhost')
        ? undefined
        : `.${this.document?.location?.host}`,
    } as CookieOptions;

  }
  set value(val: T) {

    var options = this.buildOptions()
    // if (this.isObject) {
    //   this.cook.putObject(this.key, val as any, options);
    // } else {
    this.cook.set(
      this.key,
      val as any,
      options.expires,
      options.path,
      options.domain,
    );
    // }
  }

  get value() {
    return this.cook.get(this.key) || (this.defaultValue as any);
    // return (
    // this.isObject ? this.cook.getObject(this.key) : this.cook.get(this.key)
    // ) as T;
  }

  get valueOrDefault() {
    return this.value || this.defaultValue;
  }
  get isHasValue() {
    return this.cook.check(this.key);
  }
  delete() {
    var options = this.buildOptions()
    this.cook.delete(this.key,
      options.path,
      options.domain,);
  }
}
